const MENTION_AT_CARET = /(^|\s)@([^\s@]*)$/;

/** Text after `@` at the caret, or null when the caret is not inside an @-token. */
export function mentionQueryAt(value: string, caret: number): string | null {
  const match = MENTION_AT_CARET.exec(value.slice(0, caret));
  if (!match) {
    return null;
  }
  return match[2] ?? '';
}

/** Replaces the active @-token with the chosen display name. */
export function insertMention(
  value: string,
  caret: number,
  displayName: string,
): { value: string; caret: number } {
  const match = MENTION_AT_CARET.exec(value.slice(0, caret));
  if (match?.index === undefined) {
    return { value, caret };
  }
  const start = match.index + (match[1]?.length ?? 0);
  const inserted = `@${displayName} `;
  return {
    value: `${value.slice(0, start)}${inserted}${value.slice(caret)}`,
    caret: start + inserted.length,
  };
}
